import type { Views } from "@circle-react-shared/MembersList/constants";
import {
  SORT_OPTIONS,
  VIEWS,
} from "@circle-react-shared/MembersList/constants";
import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { isCommunityAdmin } from "@circle-react/helpers/communityMemberHelpers";
import { useUsageContext } from "@circle-react/providers/UsageContext";

import type { MemberDirectorySettings } from "./constants";

export const useMemberDirectorySettings = (): MemberDirectorySettings => {
  const { isAdminUsageContext } = useUsageContext();
  const { currentCommunitySettings, currentCommunityMember, isLoading }: any =
    usePunditUserContext();

  const memberDirectorySettingsDefaultValues = {
    sort: SORT_OPTIONS[0],
  };

  const memberDirectorySettings =
    currentCommunitySettings?.member_directory_settings ||
    memberDirectorySettingsDefaultValues;

  const adminScope = {
    exclude_empty_name: isAdminUsageContext ? false : true,
  };

  const memberScope = {
    visible_in_member_directory: true,
    ...adminScope,
  };

  const scope = isCommunityAdmin(currentCommunityMember)
    ? adminScope
    : memberScope;

  const getView = () => {
    let view: Views = VIEWS.CARDS;
    if (currentCommunitySettings?.member_directory_settings?.view) {
      view = currentCommunitySettings.member_directory_settings.view;
    }
    return view;
  };

  return {
    defaultSort: memberDirectorySettings.sort,
    scope,
    view: getView(),
    isLoading,
  };
};
